import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "total"]
  static values = { unitPrice: Number, currency: String }

  updateTotal() {
    this.totalTarget.textContent = this.formatter.format(Number(this.quantityTarget.value) * this.unitPriceValue)
  }

  get formatter() {
    return new Intl.NumberFormat(document.documentElement.lang, { style: "currency", currency: this.currencyValue })
  }
}
